import {
  DeviceTypeActionNames,
  DeviceTypeState,
  DeviceTypeActionTypes,
  ConfigSupported,
  ConfigCapabilities,
} from './types';

const initialState = {
  activeDeviceTypeRecord: {
    deviceType: '',
    isDeleteConfigSupported: false,
    config: '',
    supportsTudr: false,
    commandFileTypeIds: [''],
    responseFileTypeIds: [''],
    limit: '',
    supportsDelete: false,
  },
  deviceTypePool: [
    {
      onboardApplicationMessageVersion: 1,
      deviceType: '',
      configsSupported: [
        {
          config: '',
          supportsTudr: false,
          commandFileTypeIds: [''],
          responseFileTypeIds: [''],
          limit: '',
          supportsDelete: false,
        },
      ],
    },
  ],
  deviceTypes: [''],
  commandFileTypeIds: [''],
  responseFileTypeIds: [''],
  configNames: [
    'serviceMeterHourAdjustment',
    'subscription',
    'serviceOdometerAdjustment',
    'endofDayReportTime',
    'batteryThreshold',
    'movement',
    'disableDerate',
    'userWiFi',
    'managedWiFi',
    'disableFaultCodes',
    'switch',
    'geoFence',
    'configFile',
    'remoteFlash',
    'speedFence',
    'ping',
    'transferOverride',
    'enableMaintenanceMode',
    'shortCommand',
    'shortMessageRequest',
    'reboot',
    'wakeup',
    'remoteConnectionTest',
    'fotaFirmwareUpdate',
    'systemFlash',
    'locator',
    'ntpServerSwitch',
    'backendServerSwitchIp',
    'backendServerSwitchDns',
    'plDataReset',
    'productIdChange',
    'registrationInfoCommand',
    'remoteWrite',
    'channelConfig',
  ].sort(),
};

export const deviceTypeReducer = (
  state: DeviceTypeState = initialState,
  action: DeviceTypeActionTypes,
): DeviceTypeState => {
  switch (action.type) {
    case DeviceTypeActionNames.SET_DEVICE_TYPE_CONFIG: {
      return {
        ...state,
        activeDeviceTypeRecord: action.payload,
      };
    }
    case DeviceTypeActionNames.SET_DEFAULTS: {
      let allCommandIds: string[] = [];
      let allReponseIds: string[] = [];
      // const configNameList: string[] = [];
      // for(let index = 0; index < action.payload.length; index+=1) {
      // const item = action.payload.configsSupported[index];
      // allCommandIds.concat(...item.configsSupported.map((config) => config.commandFileTypeIds));
      // }
      action.payload.forEach((record: ConfigCapabilities) => {
        record.configsSupported.forEach((config: ConfigSupported) => {
          allCommandIds = allCommandIds.concat(config.commandFileTypeIds);
          allReponseIds = allReponseIds.concat(config.responseFileTypeIds);
          // configNameList.push(config.config);
        });
      });
      return {
        ...state,
        deviceTypes: [
          ...new Set(action.payload.map((item: ConfigCapabilities) => item.deviceType)),
        ].sort(),
        commandFileTypeIds: [...new Set(allCommandIds)].sort(),
        responseFileTypeIds: [...new Set(allReponseIds)].sort(),
        // configNames: [... new Set(configNameList)].sort(),
        deviceTypePool: action.payload,
      };
    }
    default:
      return state;
  }
};
